import * as React from 'react';
import { SVGProps } from 'react';

const IconCloseSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3.757 2.343 2.343 3.757 6.586 8l-4.243 4.243 1.414 1.414L8 9.414l4.243 4.243 1.414-1.414L9.414 8l4.243-4.243-1.414-1.414L8 6.586 3.757 2.343z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
);

export default IconCloseSizeS;
